import { render } from "./LivinAmeInstructions.vue?vue&type=template&id=48c7a6ae"
import script from "./LivinAmeInstructions.vue?vue&type=script&lang=js"
export * from "./LivinAmeInstructions.vue?vue&type=script&lang=js"

import "./LivinAmeInstructions.vue?vue&type=style&index=0&id=48c7a6ae&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__